export default "__VITE_ASSET__634d0bf3__"